import { Typography, Stack } from "@mui/material";
import { useTranslations } from "next-intl";
import AadharKYCCard from "./aadhaar-card";
import { CheckboxComponent, SecureDataComponent } from "@/components";
import { WEB_COLORS } from "@/lib/constants";

export default function FaceVerificationInstructions({
  addressConsent,
  handleAddressConsent,
  handleKycConsent,
  kycConsent,
}) {
  const t = useTranslations("faceverification");
  return (
    <Stack>
      <Typography
        variant="h6"
        fontSize={{ xs: 16, md: 20, lg: 24 }}
        color={WEB_COLORS.darkTeal}>
        {t("tittle1")}
      </Typography>
      <Stack spacing={{ xs: 1, sm: 4 }}>
        <Typography color={"rgba(31, 31, 31, 0.8)"} fontSize={12} mb={0.5}>
          {t("note")}
        </Typography>
        <AadharKYCCard />
      </Stack>

      <Stack my={1} mx={1} mt={{ xs: 1, sm: 5 }}>
        <Typography
          color={WEB_COLORS.textFadeColor}
          fontWeight={400}
          fontSize={{ md: "14px", xs: "12px" }}
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          By Proceeding, I consent to Hero FinCorp fetching my KYC via
          DigiLocker/Aadhaar through HyperVerge for my loan application.
        </Typography>
      </Stack>
      <Stack spacing={2} mt={2}>
        <CheckboxComponent
          onChange={handleAddressConsent}
          name="addressConsent"
          checked={!!addressConsent}
          color={WEB_COLORS.errorColor}
          label={
            <Typography
              color={WEB_COLORS.textFadeColor}
              fontWeight={400}
              fontSize={{ md: "14px", xs: "12px" }}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              I confirm that the address fetched via Digi KYC is my current
              address.
            </Typography>
          }
        />
        <CheckboxComponent
          name="consent"
          onChange={handleKycConsent}
          checked={!!kycConsent}
          color={WEB_COLORS.errorColor}
          label={
            <Typography
              color={WEB_COLORS.textFadeColor}
              fontSize={{ md: "14px", xs: "12px" }}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {t("digikycconsent")}
            </Typography>
          }
        />

        <SecureDataComponent />
      </Stack>
    </Stack>
  );
}
